import { apiPath } from '../../../config';
import { axiosInstance } from '../AxiosInstance';

export const getAllTags = async () => {
  return axiosInstance.get(apiPath.tags);
};

export const createTag = async (payload) => {
  return axiosInstance.post(apiPath.tags, payload);
};

export const updateTag = async ({ id, payload }) => {
  return axiosInstance.patch(`${apiPath.tags}/${id}`, payload);
};

export const deleteTag = async (id) => {
  return axiosInstance.delete(`${apiPath.tags}/${id}`);
};
